import { CheckoutInitialisation } from '../../models/checkout/checkout-initialisation.interface';
import { PropositionType } from '../../models/global-checkout/proposition-types.enum';
import { mockCheckoutBasket } from './checkout-basket.mock';
import { mockCheckoutCustomerDetails } from './checkout-customer-details.mock';

export const mockCheckoutInitialisation: CheckoutInitialisation = {
  authToken: 'auth_token',
  basket: mockCheckoutBasket,
  customer: mockCheckoutCustomerDetails,
  proposition: { type: PropositionType.MonthlySubs },
};
